import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { MediaBankConfirmDeleteListItemUsesComponent } from './media-bank-confirm-delete-list-item-uses/media-bank-confirm-delete-list-item-uses.component';
import { MediaBankConfirmDeleteViewRowComponent } from '@fi-app/media-bank/media-bank-confirm-delete/media-bank-confirm-delete-view-row/media-bank-confirm-delete-view-row.component';
import { ItemsListRowComponent } from '@fi-app/components/items-list/list-row/list-row.component';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { MediaBankService } from '@fi-app/media-bank/media-bank.service';
import { IMediaBankFile } from '@fi-shared/media-bank/media-bank';
import { AppTextService } from '@fi-shared/app-text';
import { MediaBankListData } from '@fi-app/media-bank/media-bank-list-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { UserService } from '@fi-app/user/user.service';

export interface MediaBankConfirmDeleteData {
    selectedItems: IMediaBankFile[];
    listData: MediaBankListData;
}

@Component({
    selector: 'fi-media-bank-confirm-delete',
    templateUrl: './media-bank-confirm-delete.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./media-bank-confirm-delete.component.scss'],
    standalone: false,
})
export class MediaBankConfirmDeleteComponent
    extends FiDialogsContentBase<MediaBankConfirmDeleteData, IMediaBankFile[]>
    implements OnInit
{
    listData: MediaBankListData;
    inUseCount: number;
    loaded: boolean;
    listRow: ItemsListRowComponent<any>;

    ngOnInit() {
        const mediaBankService = this.injector.get(MediaBankService);
        const appTextService = this.injector.get(AppTextService);
        const userService = this.injector.get(UserService);
        const data: any[] = this.data.selectedItems.map((a) => Object.assign({}, a));

        data.forEach((file) => (file.Checked = true));

        this.inUseCount = this.data.selectedItems.filter((file) => file.IsInUse === true).length;

        this.loaded = false;

        this.listData = this.data.listData;
        this.listData.Statefull = false;
        this.listData.loadDataFunc = null;
        this.listData.loadCountFunc = null;
        this.listData.ShowFavoriteIcon = false;
        this.listData.ShowDelete = false;
        this.listData.RowIsClickable = false;
        this.listData.Header = [this.listData.Header[0], this.listData.Header[1], this.listData.Header[4]];

        this.listData.Header[0].Properties.ElementType = ItemsListElementType.ImgIcon;
        this.listData.Header[1].Properties.ElementType = ItemsListElementType.SpanPlain;
        this.listData.Header[2].Properties.ElementType = ItemsListElementType.SpanPlain;
        this.listData.Header[2].Properties.ExtraProperties = {
            onClick: ($event, data) => userService.openUserViewDialog(data.CreatedByUserId),
        };

        this.listData.Header.push(
            new ItemsListHeader(
                appTextService.get('mediaModule.used_in'),
                'UsedIn',
                new ItemsListHeaderProperties('', false, MediaBankConfirmDeleteListItemUsesComponent),
            ),
        );

        this.listData.listRowAfterComponentType = MediaBankConfirmDeleteViewRowComponent;

        this.listData.appendData(data);
        this.listData.SelectedItems = data.slice(0, data.length);

        mediaBankService.GetMediaBankFileUsages(data.map((file) => file.Id)).then((response) => {
            this.loaded = true;

            const listDataMap = {};
            this.listData.Data.forEach((file: any) => {
                listDataMap[file.Id] = file;
                file.UsesItems = [];
            });

            response.forEach((item) => listDataMap[item.MediaBankFileId].UsesItems.push(item));

            for (let prop in listDataMap) {
                listDataMap[prop].UsedIn = listDataMap[prop].UsesItems.length;
            }
        });
    }

    getResult() {
        const selectedIds = this.listData.SelectedItems.map((item) => item.Id);
        return this.data.selectedItems.filter((item) => selectedIds.indexOf(item.Id) > -1);
    }

    isYesButtonDisabled() {
        return !this.loaded || this.listData.SelectedItems.length === 0;
    }
}
